import { ReactElement} from "react";
import { useLocalization } from '@progress/kendo-react-intl';
import { enMessages } from "../../../../messages/en-US";
import { EventFilter } from "../../../Events/Utilities/EventsApiService";
import { graphIcon } from '@progress/kendo-svg-icons';
import { SvgIcon } from "@progress/kendo-react-common";

interface Props {
  selectedItem: string
  eventFilter: EventFilter
}

export default function LocationDetailsPage(props: Props): ReactElement {
  const localizationService = useLocalization();

  return (
        <div className="tabstrip h-full">
            <div className="gb-text-normal  text-lg text-center"
              style={{width: '400px', borderRadius: '3px', padding: '40px 25px',margin: '30px auto'}}>
              <div className="text-center mb-5">
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '70px',
                  height: '70px'
                }}>
                  <SvgIcon icon={graphIcon} size="xxxlarge" />
                </span>
              </div>
              <div>
                <span>{`${localizationService.toLanguageString('custom.selectPointEndpoint', enMessages.custom.selectPointEndpoint)}`}</span>
              </div>
            </div> 
        </div>
  )
}
